'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MPPDataPoint = function MPPDataPoint(props) {
  var classes = (0, _classnames2.default)('mpp-data-point', 'text-xs-center', props.className);
  return _react2.default.createElement(
    'i',
    { className: classes },
    _react2.default.createElement(
      'span',
      { className: 'text' },
      _react2.default.createElement(
        'span',
        { className: 'stats-text' },
        props.stats.text
      ),
      _react2.default.createElement(
        'span',
        { className: 'description-text' },
        props.description.text
      )
    )
  );
};

exports.default = MPPDataPoint;


MPPDataPoint.defaultProps = {
  stats: {
    text: '179M'
  },
  description: {
    text: 'active PayPal accounts'
  },
  className: ''
};

MPPDataPoint.propTypes = {
  className: _propTypes2.default.string,
  stats: _propTypes2.default.shape({
    text: _propTypes2.default.string
  }),
  description: _propTypes2.default.shape({
    text: _propTypes2.default.string
  })
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/atoms/data-point/jsx/MPPDataPoint.js
// module id = 659
// module chunks = 4